type Props = {
  images: string[];
};

const PropertyImagesViewer = ({ images }: Props) => {
  if (images?.length === 0) {
    return null;
  }
  return (
    <div>
      {images?.map((img, index) => (
        <img
          key={img}
          src={img}
          alt={`propertyImage-${index}`}
          style={{ height: "100px", width: "150px" }}
        />
      ))}
    </div>
  );
};

export default PropertyImagesViewer;
